import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { IQuestionnaireAnswer, QuestionnaireAnswer } from '../QuestionnaireAnswer.ts';
import { QuestionnaireAnswerApi } from '../../../apis/QuestionnaireAnswerApi/QuestionnaireAnswerApi.ts';
import { useBaseQuery } from '../../../queryDefaults/baseQueries/useBaseQuery.tsx';

export function useGetQuestionnaireAnswerByTaskIdParam(taskId: number | null | undefined) {
    return useBaseQuery({
        queryKey: [QueryKeys.questionnaireAnswer, taskId],
        queryFn: async () => {
            const result: IQuestionnaireAnswer = await QuestionnaireAnswerApi.getQuestionnaireAnswerByTaskId(
                String(taskId),
            );
            return new QuestionnaireAnswer(result);
        },
        enabled: !!taskId,
        staleTime: 3600000,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchInterval: false,
    });
}
